<template>
    <main class="login-page flex">
        <form class="login-form" action="/login" method="post">
            <input type="hidden" name="_token" :value="csrf">
            <h2> {{ trans('Log in') }} </h2>
            <div class="login-form__content">
                <div class="input-wrapper">
                    <span class="input-wrapper__title">EMAIL</span>
                    <input v-model="email" id="email" type="email"
                           class="input-element input-wrapper__element-inp form-control "
                           name="email" value="" required="" autocomplete="email" autofocus="">


                </div>
                <div class="input-wrapper">
                    <span class="input-wrapper__title">{{ trans("Password") }}</span>
                    <input v-model="password" id="password" type="password"
                           class="input-element input-wrapper__element-inp "
                           name="password" required="" autocomplete="current-password">


                </div>

                <a @click="airShow= !airShow" class="login-form__link login-form__password-recovery-link air-js">
                    {{ trans("Forgot Your Password") }} ? </a>


            </div>

            <div class="login-form__checkboxes">
                <div class="input-wrapper login-form__checkbox-wrapper">
                    <label class="input-wrapper__title input-checkbox__wrapper login-form__checkbox-title">
                        <input v-model="checkbox" type="checkbox" class="input-checkbox" name="remember" id="remember">
                        <span> {{ trans("remember") }} </span>
                    </label>
                </div>
                <div class="input-wrapper login-form__checkbox-wrapper">
                    <label class="input-wrapper__title input-checkbox__wrapper login-form__checkbox-title">
                        <input v-model="subscribe" type="checkbox" class="input-checkbox" name="subscribe"
                               value="1"><span> {{ trans("Subscribe to the news") }} </span></label>
                </div>
            </div>
            <div class="login-form__footer">
                <button type="submit" class="btn btnV2 " >{{ trans("Enter") }}</button>
                <a href="/register" class="login-form__link user-account__big-text-line">
                    {{ trans("Registration") }}
                </a>
            </div>


            <SOCIAL/>


        </form>
    </main>
    <div class="air-container  " id="forgotPassword" :class="airShow ? 'air-container_active':''">
        <div class="popup-air  " :class="airShow ? 'popup-air_active':''">
            <div class="air-close" @click="airShow = !airShow"></div>
            <div class="form-popup">
                <p class="form-popup__title">{{ trans("Password Recovery") }}</p>
                <p class="form-popup__subtitle">{{ trans("We will send you a link to reset your password") }}</p>
                <form class="form-popup__form-wrapper">
                    <div class="form-popup__inp-wrapper password-recovery__email" style="width: 100%">
                        <input v-model="forgot_email" id="forgot-email" name="email" type="text"
                               :placeholder="this.trans('Mail (E-mail)')" class="input-element form-popup__input">
                    </div>
                    <div class="form-popup__submit-wrapper">
                        <input @click.prevent="checkEmail" class="input-element btnV2" type="submit" value="Отправить">
                    </div>
                </form>
            </div>
        </div>
    </div>

</template>

<script>
import SOCIAL from "./social-lite.vue"

export default {
    components: {
        SOCIAL
    },

    name: "login",
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            email: '',
            password: '',
            checkbox: true,
            subscribe: true,
            forgot_email: '',
            airShow: false,
            error_message: false,

        }
    },

    mounted() {



    },

    methods: {
        telegramLoadedCallbackFunc() {


        },
        yourCallbackFunction(user) {
            this.email = user.id + "@telegram.ru"
            this.name = user.first_name + ' ' + user.username
            axios.get('/api/v1/set-user-social', {
                params: {
                    id: user.id,
                    email: this.email,
                    name: this.name,
                }


            }).then(data => {
                this.password = data.data

                this.login()
            })

        },
        validateEmail(email) {

            const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
            if(emailRegex.test(email)){
                return true
            }else {
                this.$notify({
                    title: this.trans('Error'),
                    text: this.trans('Incorrect email address'),
                    type: 'error',
                });
            }
        },

        loginValidate() {


                this.error_message = false
                if (this.email === '') {
                    this.error_message = true
                }
                if (this.password === '') {
                    this.error_message = true
                }

                if (this.error_message){
                    this.$notify({
                        title: this.trans('Error'),
                        text: this.trans('Fill in all the fields'),
                        type: 'error',
                    });
                }else{
                    return true;
                }
                return false;


        },
        async checkEmail() {
            if(this.validateEmail(this.forgot_email)) {
                this.airShow = false
                try {
                    await axios.post('/password/email', {
                        email: this.forgot_email
                    })
                    .then(data => {

                        this.$notify({
                            title: data.data.title,
                            text: data.data.text,
                            type: data.data.status,
                        });
                    })
                } catch (error) {
                    console.log(error.status)
                    this.$notify({
                        title: this.trans('Error'),
                        text: this.trans(error.response.data.message),
                        type: 'error',
                    });
                }

            } else {
                this.$notify({
                    title: this.trans('Error'),
                    text: this.trans('Incorrect email address'),
                    type: 'error',
                });
            }
        },

        getUser() {
            axios.get('/api/v1/get-user', {
                params: {
                    email: this.email,
                }


            }).then(data => {

                this.$store.state.settings.user = data.data
                this.updateStorage(this.$store.state.settings)
            }).then(r => {

                this.$router.push({name: 'personal'})
            }).catch(err => {
                this.$router.push({name: 'login'})
            })


        },
        login() {

            if ( this.loginValidate() && this.validateEmail(this.email)){
                axios.get('/sanctum/csrf-cookie').then(response => {

                    axios.post('/login', this.setParam({
                        email: this.email,
                        password: this.password
                    }))
                        .then(this.getUser)
                        .catch(err => {

                        this.$notify({
                            title: this.trans('Error'),
                            text: this.trans(err.response.data.message),
                            type: 'error',
                        });
                    })
                });
            }


        }
    }
}
</script>

<style scoped>
.login-page {
    margin: 0 auto;
}


</style>
